import i18n from "../../../constants/i18n";
import getCorePopUpStore from "../../../stores/core/core-popup-store";
import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import Et3Text from "../../et3-text";
import PopUpCloseButton from "../../et3-shared-components/action-buttons/popUpCloseButton";

const AlbumTitle = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={1400}
      height={100}
      fDirection="column"
      alignItems="flex-end"
      justifyContent="center"
      color={colors.all.white}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={850}
        height={100}
        fDirection="row"
        alignItems="center"
        justifyContent="space-between"
        color={colors.all.white}
        style={{}}
        onClick={() => {}}
      >
        <Et3Text
          text={i18n.get("USER_ALBUM_PICTURES")}
          fontFamily="BOLD"
          fontSize={20}
          color={colors.all.black}
          isSpan={true}
          style={{}}
        />
        <PopUpCloseButton
          onClick={() => getCorePopUpStore().isPicAlbumPopUpVisible.set(false)}
        />
      </ET3Div>
    </ET3Div>
  );
});
export default AlbumTitle;
